const analyticsEvents = {
  ERROR: 'towns_from_error',
  SUCCESS: 'towns_from_success',
};

export const townFromConfig = {
  analyticsEvents,
};
